<template>
    <div v-if="daily" class="daily-comment">
        <el-tooltip class="item" effect="dark" content="我要评价" placement="bottom">
            <i class="icon iconfont icon-button icon-comment" @click="openUrl"></i>
        </el-tooltip>
    </div>
</template>
<script>
import envConfig from '@/config/user.env.js';
import { mapGetters } from 'vuex';
import { getTmpToken } from '@/components/utils/userApi.js';
export default {
    name: 'comment',
    props: {
        monthly: { // 是否开启月评价
            type: Boolean,
            default: false
        },
        daily: { // 是否开启日评价
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            // appList: [],
            loadFlag: true // 是否已加载标识
        };
    },
    methods: {
        /**
         * @description: 获取当前系统名称
         * @return {string} 返回系统名称字符串
         */
        getSystemName() {
            const currentPath = this.appList.find(item => {
                if (item.applicationDomain) {
                    return item.applicationCode === (this.$store.state.currentApplicationCode || this.$store.state.applicationCode);
                }
                return false;
            });
            if (currentPath && currentPath.applicationName) {
                return currentPath.applicationName;
            } else {
                return '';
            }
        },
        /**
         * @description: 打开指定日评价网址
         */
        async openUrl() {
            let tmpToken = '';
            if (location.origin.indexOf('annto.com') === -1) { // 跨域获取临时token
                const res = await getTmpToken({});
                if (res && res.code === '0') {
                    tmpToken = res.data;
                }
            }
            let url = `${envConfig.commentUrl}/plugins/daily.html?tenantCode=${this.currentTenant.tenantCode}
                 &userId=${this.user.userCode}&userName=${this.user.userName}
                 &systemName=${this.getSystemName()}&apiurl=${envConfig.apiUrl}&pageUrl=${document.location.href}`;
            tmpToken.length && (url += `&tmpToken=${tmpToken}`);
            url = url.replace(/\ +/g, '').replace(/[\r\n]/g, ''); // 去掉回車空格
            url = encodeURI(encodeURI(url));
            window.open(url);
        },
        /**
         * @description: 加载每月评价的script文件并执行初始化
         */
        loadScript() {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = `${envConfig.commentUrl}/plugins/js/monthly.js`;
            script.onload = () => {
                window._initMonthlyComment({
                    systemName: this.getSystemName(),
                    userId: this.user.userCode,
                    userName: this.user.userName,
                    tenantCode: this.currentTenant.tenantCode
                });
            };
            document.head.appendChild(script);
        }
    },
    computed: {
        ...mapGetters(['user', 'currentTenant', 'appList'])
    },
    watch: {
        appList: {
            handler(val) {
                if (val.length > 0 && this.loadFlag) {
                    this.monthly && this.loadScript();
                    this.loadFlag = false;
                }
            },
            immediate: true
        }
    }/* ,
    mounted() {
         return getUserApplications({
            userCode: this.user.userCode,
            tenantCode: this.currentTenant.tenantCode
        }).then(response => {
            if (response && +response.code === 0) {
                this.appList = response.data;
                this.monthly && this.loadScript();
                this.loadFlag = false;
            }
        });
    } */
};
</script>
<style lang="less">
    .daily-comment {
        display: inline-block;
        margin-right: 20px;
        .icon-comment {
            font-size: 20px;
            color: #555757;
            cursor: pointer;
            vertical-align: middle;
        }
    }
</style>
